(function () {
  'use strict';
  if (window.SWShippingLookupAdapters) return;
  var OWNER = '[data-sw-shipping-owner]';
  function apply(target, detail) {
    if (!target || !target.closest) return;
    var owner = target.matches && target.matches(OWNER) ? target : target.closest(OWNER);
    if (!owner) return;
    var selected = Boolean(detail && detail.initialized && detail.hasAnswer && detail.open);
    owner.classList.toggle('sw-shipping-owner--has-answer', selected);
    owner.classList.toggle('sw-shipping-owner--ready', Boolean(detail && detail.initialized));
    owner.querySelectorAll('[data-sw-shipping-source-link]').forEach(function (link) {
      if (link.closest(OWNER) === owner) link.hidden = Boolean(detail && detail.initialized);
    });
    owner.querySelectorAll('[data-sw-shipping-source-label]').forEach(function (label) {
      if (label.closest(OWNER) === owner) label.hidden = !Boolean(detail && detail.initialized);
    });
    owner.querySelectorAll('[data-sw-shipping-overview]').forEach(function (overview) {
      if (overview.closest(OWNER) === owner) overview.hidden = selected;
    });
  }
  function init(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var roots = Array.from(scope.querySelectorAll('[data-sw-shipping-lookup]'));
    if (scope.matches && scope.matches('[data-sw-shipping-lookup]')) roots.unshift(scope);
    roots.forEach(function (root) {
      var owner = root.closest(OWNER);
      if (!owner || root.dataset.swLookupDuplicate === 'true') return;
      var primary = Array.from(owner.querySelectorAll('[data-sw-shipping-lookup]')).find(function (candidate) {
        return candidate.closest(OWNER) === owner && candidate.dataset.initialized === 'true';
      });
      if (primary && primary !== root) return;
      var disclosure = root.querySelector('[data-sw-lookup-disclosure]');
      var status = root.querySelector('[data-sw-lookup-status]');
      var selected = status && ['fast', 'standard', 'special', 'clarify'].indexOf(status.dataset.state) !== -1;
      apply(root, { initialized: root.dataset.initialized === 'true', hasAnswer: selected, open: (root.dataset.swLookupLayout === 'compact' && ((root.dataset.swLookupPlacement === 'pasta-shipping' && owner.hasAttribute('data-sw-pasta-delivery-pilot')) || (root.dataset.swLookupMode === 'regular' && ['approved-product', 'delivery-information'].indexOf(root.dataset.swLookupPlacement) !== -1 && owner.hasAttribute('data-sw-product-delivery-card')))) || (disclosure && disclosure.open) });
    });
  }
  document.addEventListener('sw:shipping-lookup:state', function (event) { apply(event.target, event.detail); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.SWShippingLookupAdapters = { init: init };
  init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
})();
